export const styles = theme => ({
  textBlock: {
    paddingBottom: theme.spacing.unit
  },
  textList: {
    margin: 0
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/styles/components/PatchNotes.js